import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getCurrentUser, insertTaxList } from "../../api-config/config";
import "../ReservationForm/BookingForm.css";

const NewTaxForm = (props: any) => {
  const { handleClose, onTaxAdded, showSnackbar } = props;
  const loggedUser = getCurrentUser();

  const defaultValues = {
    tax_type: "",
    name: "",
    value: 0,
    min_amount: 0,
    max_amount: 0,
  };

  const formValidation = Yup.object().shape({
    tax_type: Yup.string().required("Please enter tax type"),
    name: Yup.string().required("Please enter name"),
    value: Yup.number().required("Please enter tax value"),
    min_amount: Yup.number().required("Please enter min amount"),
    max_amount: Yup.number().required("Please enter max amount"),
  });

  const handleSubmit = async (formData: any) => {
    try {
      formData.hotel_code = loggedUser?.hotel_code;

      const response = await insertTaxList(formData);

      if (response?.status_message === "failed") {
        showSnackbar(response.message || "Failed to add tax", "error");
        return;
      }

      showSnackbar("Tax added successfully", "success");
      onTaxAdded();
      handleClose();
    } catch {
      showSnackbar("Something went wrong", "error");
    }
  };

  return (
    <div className="booking-form-wrapper">
      <Formik
        initialValues={defaultValues}
        validationSchema={formValidation}
        onSubmit={handleSubmit}
      >
        <Form className="grid lg:grid-cols-1 p-8">
          <div className="grid gap-4 lg:grid-cols-2">
            <div className="form-group">
              <label>
                Tax Type <span style={{ color: "red" }}>*</span>
              </label>
              <Field name="tax_type" className="con-field" placeholder="Enter tax type" />
              <p className="text-red-600">
                <ErrorMessage name="tax_type" />
              </p>
            </div>

            <div className="form-group">
              <label>
                Tax Name <span style={{ color: "red" }}>*</span>
              </label>
              <Field name="name" className="con-field" placeholder="Enter tax name" />
              <p className="text-red-600">
                <ErrorMessage name="name" />
              </p>
            </div>
          </div>

          <div className="form-group">
            <label>
              Value <span style={{ color: "red" }}>*</span>
            </label>
            <Field name="value" type="number" min={0} className="con-field" />
            <p className="text-red-600">
              <ErrorMessage name="value" />
            </p>
          </div>

          <div className="grid gap-4 lg:grid-cols-2">
            <div className="form-group">
              <label>
                Min Amount <span style={{ color: "red" }}>*</span>
              </label>
              <Field name="min_amount" type="number" min={0} className="con-field" />
              <p className="text-red-600">
                <ErrorMessage name="min_amount" />
              </p>
            </div>

            <div className="form-group">
              <label>
                Max Amount <span style={{ color: "red" }}>*</span>
              </label>
              <Field name="max_amount" type="number" min={0} className="con-field" />
              <p className="text-red-600">
                <ErrorMessage name="max_amount" />
              </p>
            </div>
          </div>

          <div className="form-actions pt-4">
            <div>
              <button type="button" className="my-custom-btn" onClick={handleClose}>
                Cancel
              </button>
            </div>

            <div>
              <button type="submit" className="my-custom-btn">
                Save
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default NewTaxForm;